import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

// Initialize Sentry
Sentry.init({
  dsn: import.meta.env.REACT_APP_SENTRY_DSN || '',
  environment: import.meta.env.MODE === 'production' ? 'production' : 'development',
  enabled: import.meta.env.MODE === 'production',
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  initialScope: {
    tags: { app: 'ordering' },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
